module.exports = __webpack_public_path__ + "static/img/default_image.b4e92528.png";